import React, { Component } from 'react';

export class BotAdvertBanner extends Component {
    render() {
        const { name, description, imageUrl } = this.props;
        return (
            <div className="w-full bg-gradient-to-r from-[#4776E6] to-[#38d9d9] rounded-lg p-8 my-12">
                <div className="flex flex-col md:flex-row items-center gap-8">
                    <div className="w-24 h-24 md:w-32 md:h-32 rounded-full overflow-hidden flex-shrink-0 bg-white/10 p-1">
                        <img src={imageUrl} alt={name} className="w-full h-full object-cover rounded-full" />
                    </div>
                    <div className="flex-grow">
                        <div className="flex flex-col items-center md:items-start">
                            <h2 className="text-2xl font-bold text-white mb-3">{name}</h2>
                            <p className="text-white/90 text-base md:text-lg mb-6 text-center md:text-left">Want to try this Moderation module without limits? Invite our public bot GhostBuddy to your server - it comes with advanced auto-moderation, logging, and powerful moderation tools!</p>
                            <div className="flex flex-wrap gap-4">
                                <a href="https://top.gg/bot/1331245032568524861" target="_blank" rel="noopener noreferrer" className="bg-white text-[#4776E6] px-8 py-3 rounded-md hover:bg-white/90 transition-colors font-semibold">
                                    Invite GhostBuddy
                                </a>
                                <a href="https://top.gg/bot/1331245032568524861" target="_blank" rel="noopener noreferrer" className="border-2 border-white text-white px-8 py-3 rounded-md hover:bg-white/10 transition-colors font-semibold">
                                    Learn More
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BotAdvertBanner; 